import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputBooleanIsFalseErrorMessage = (
  <Trans>
    Ce champ doit être non coché
  </Trans>
);
